import { Component, HostListener, OnInit } from '@angular/core';
import { CheckAuth } from 'src/Services/utility.service';
import { CountyMasterService } from 'src/Services/county-master.service';
import { CountyMaster911Model } from 'src/Models/CountyMaster911Model';
import { Router } from '@angular/router';
import { StateMasterService } from 'src/Services/state-master.service';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-county',
  templateUrl: './county.component.html',
  styleUrls: ['./county.component.css']
})
export class CountyComponent implements OnInit {

  tokenKey: string='';
  listofCounty: CountyMaster911Model[]=[];
  listofCountyExport: CountyMaster911Model[]=[];
  PageNumber: number = 1;
  PageSize: number = 10;
  isRecord: boolean = false;
  isloading: boolean = false;
  totalRecordCount: number = 0;
  stateId: string = '';
  filterText: string = '';
  SelectedTool: string;
  stateList: StateMasterModel[] = [];
  orderBy: string = 'SortOrder';
  isAscending: boolean = false;
  upDowNameCSS: string = '';
  upDowShortNameCSS: string = '';
  upDowActiveCSS: string = '';
  upDowSortCSS: string = '';

  dropdownListState:any = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds:any = [];
  module = '911';
  countyId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly countyService: CountyMasterService, private readonly stateService: StateMasterService,private readonly router: Router, private readonly checkAuth: CheckAuth, private readonly toastr: ToastrService,private readonly titleService: Title, private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('County');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.getState();
    this.GetAllCounty();
    this.dropdownSettingsState = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
  }

  keywordFilters($event) {
    this.filterText = $event.target.value;
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetAllCounty();
  }

  GetAllCounty() {
    this.isloading = true;
    this.listofCounty=[];
    let state = '';
    if (this.listOfStateIds.length > 0) {
      state = this.listOfStateIds.join(',')
    }
    this.countyService.GetAllCounty(this.tokenKey, this.PageNumber, this.PageSize, this.filterText, state, this.orderBy,false).subscribe(
      data => {
        this.isloading = false;
        this.listofCounty = data['county'];
        if (this.listofCounty != null) {
          if (this.listofCounty.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofCounty[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { }
    );
  }

  addCounty() {
    let navigation = '/admin/' + this.SelectedTool + '/county/manage';
    this.router.navigate([navigation]);
  }

  updateCounty(countyId) {
    let navigation = '/admin/' + this.SelectedTool + '/county/manage/' + countyId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.countyId = id;
  }

  deleteCounty(countyId) {
    this.isloading = true;
    this.countyService.DeleteCounty(this.tokenKey, countyId).subscribe(
      data => {
        this.GetAllCounty();
        if (data['message'] != "")
          this.showMessage(data['message'], 'Warning', 'warning')
        else
          this.toastr.success('County deleted successfully.', 'Delete')
      },
      error => { }
    );
  }

  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name })
          });
        }
      },
      error => { }
    );
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  onSelectAll($event) {
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  onDeSelectAllState($event) {
    this.listOfStateIds = [];
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  clear() {
    this.stateId = '';
    this.filterText = "";
    this.listOfStateIds = [];
    this.selectedItemsState = [];
    this.GetAllCounty();
  }
  
  sort(sortBy: any) {
    this.upDowNameCSS = '';
    this.upDowShortNameCSS = '';
    this.upDowActiveCSS = '';
    this.upDowSortCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "CountyName") {
        this.upDowNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Name") {
        this.upDowShortNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsActive") {
        this.upDowActiveCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "CountyName") {
        this.upDowNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Name") {
        this.upDowShortNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsActive") {
        this.upDowActiveCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetAllCounty();
  }  


  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  onFilterSelectAllState($event){
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  onFilterDeSelectAllState($event){
     for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
        }
      }
    }
    this.PageNumber = 1;
    this.GetAllCounty();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  Export911County() {
    this.isloading = true;
    this.listofCountyExport=[];
    let state = '';
    if (this.listOfStateIds.length > 0) {
      state = this.listOfStateIds.join(',')
    }
    this.countyService.GetAllCounty(this.tokenKey, this.PageNumber, this.PageSize, this.filterText, state, this.orderBy,true).subscribe(
      data => {
        this.listofCountyExport = data['county'];
        if (this.listofCountyExport != null) {
          if (this.listofCountyExport.length > 0){
            setTimeout(() => {
              this.Download911County();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else{
          this.isloading = false;
            this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
       }
    );
  }

  Download911County() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'Export911County';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "Export911County.xls");
  }
}
